export function CreateItem(Create, bean, type, list) {

    Create(bean)
        .then(() => {
            //console.log(type,"added")
            if(list!=undefined){
                list()
            }
        })
        .catch(err => {
            //console.log(err.response)
        })

}